import {HttpInterceptorService} from './services/http-interceptor.service';
import {OverlayLoaderComponent} from './components/overlay-loader/overlay-loader.component';
import {CoreActionCreatorService} from './services/core-action-creator.service';
import {TranslationHandlerService} from './services/translation-handler.service';
import {IspmHttpClient} from './services/ispm-http-client';
import {IspmRevisionContextHttpClient} from '@ispm/core/services/ispm-revision-context-http-client';
import {HeartBeatService} from './services/heart-beat.service';
import {LogService} from './services/log.service';
import {BrowserCacheService} from "@ispm/core/services/browser-cache.service";
import {SessionRefreshService} from "@ispm/core/services/session-refresh.service";
import {EnumService} from '@ispm/user/services/enum.service';
import {ActivityService} from '@ispm/user/services/activity.service';
import {CryptoService} from '@ispm/migration/services/crypto.service';
import {TherapyMatchService} from '@ispm/migration/services/therapy-match.service';
import {ReportPreviewService} from "@ispm/therapies/services/report-preview.service";
import {PractitionerService} from "@ispm/migration/services/practitioner.service";
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {AberrationService} from '@ispm/migration/services/aberration.service';
import {OrganizationService} from "@ispm/migration/services/organization.service";
import {LogServiceHelper} from "@ispm/core/services/log-service-helper.service";
import {WebMessagingService} from "@ispm/core/services/web-messaging.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {NavigationHelperService} from "@ispm/core/services/navigation-helper.service";

export const CoreComponents = [
  OverlayLoaderComponent
];

export const CoreServices = [
  HttpInterceptorService,
  TranslationHandlerService,
  CoreActionCreatorService,
  IspmHttpClient,
  IspmRevisionContextHttpClient,
  RouterManagerService,
  NavigationHelperService,
  HeartBeatService,
  LogService,
  BrowserCacheService,
  SessionRefreshService,
  WebMessagingService,
  EnumService,
  ActivityService,
  CryptoService,
  TherapyMatchService,
  ReportPreviewService,
  AberrationService,
  AuthenticationService,
  OrganizationService,
  PractitionerService,
  LogServiceHelper
];
